var isFunction = function(fn) {
  return fn && {}.toString.call(fn) === '[object Function]';
}

module.exports = {
  isFunction: isFunction
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/addsearch-js-client/src/util.js
// module id = 771
// module chunks = 0